<template>
  <div class="notifications card text-md" id="tpl_travelBuddyAssigned_popup">
    <div class="cursor-pointer absolute right-5 hover:text-[var(--color-orange)]" id="btn_close">
      <i @click.prevent="deactivate()">
        <font-awesome-icon icon="fa-xmark" />
      </i>
    </div>
    <div class="text-justify p-5">
      <div class="flex break-words items-start">
        <h3 v-if="headerText" class="pl-0">
          <span id="tpl_travelBuddyAssigned_popup_header">{{ headerText }}</span>
        </h3>
      </div>
      <div v-if="bodyText" class="flex break-normal mt-2">
        <h4 id="tpl_travelBuddyAssigned_popup_text" class="break-normal">
          {{ bodyText }}
        </h4>
      </div>
    </div>
    <div class="flex justify-end">
      <button
        type="button"
        class="block mr-5 ml-auto mt-4 py-3 px-9 rounded-full
         text-lg bg-[var(--color-orange)] text-center text-inherit border-0 cursor-pointer"
        id="btn_travelBuddyAssigned_open"
        @click="openDevelopmentPartnerView"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
const DEFAULT_ROUTE = '/travel-buddy-history';

export default {
  name: 'TravelBuddyAssignedNotificationComponent',
  props: ['notification'],
  computed: {
    lang() {
      return this.$i18n?.locale || 'en';
    },
    content() {
      return this.notification?.content || {};
    },
    headerText() {
      const header = this.content.header;
      if (header && typeof header === 'object') {
        return header[this.lang] || header.en || header.de || '';
      }
      return '';
    },
    bodyText() {
      const text = this.content.text;
      if (text && typeof text === 'object') {
        return text[this.lang] || text.en || text.de || '';
      }
      return typeof text === 'string' ? text : '';
    },
    buttonText() {
      const btn = this.content.positiveButton;
      if (btn && typeof btn === 'object') {
        return btn[this.lang] || btn.en || btn.de || '';
      }
      return this.lang === 'de'
        ? 'Entwicklungspartner-Ansicht öffnen'
        : 'Open development partner view';
    },
    routePath() {
      const route = this.content.route || this.content.path;
      if (typeof route === 'string' && route.startsWith('/')) {
        return route;
      }
      const link =
        this.content.travelBuddyLink ||
        this.content.link ||
        this.content.tenantUrl ||
        '';
      if (typeof link === 'string' && link.includes('/travel-buddy-history')) {
        return DEFAULT_ROUTE;
      }
      return DEFAULT_ROUTE;
    },
  },
  methods: {
    deactivate() {
      this.$store.dispatch('deactivatePopUp', this.notification._id);
    },
    async openDevelopmentPartnerView() {
      // Same-window SPA navigation (assessments use router-link; avoid target=_blank
      // and avoid deactivating before navigation — that cancelled the click).
      try {
        await this.$router.push(this.routePath);
      } catch (err) {
        // Ignore duplicated navigation; still close the popup.
      }
      this.deactivate();
    },
  },
};
</script>
